import React, { useState } from 'react';
import Header from '../components/Header';
import StatsCards from '../components/StatsCards';
import AccountGrowthChart from '../components/AccountGrowthChart';
import TopRatedList from '../components/TopRatedList';

const الرئيسية = ({ toggleSidebar, isSidebarOpen }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
    // Force reload page data
    window.location.reload();
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      {/* Header */}
      <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      
      {/* Main Content Container */}
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        boxSizing: 'border-box'
      }}>
        {/* Refresh Button */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%'
        }}>
          <button
            onClick={handleRefresh}
            style={{
              padding: '10px 20px',
              borderRadius: '12px',
              border: 'none',
              backgroundColor: '#E96A3A',
              color: '#FFFFFF',
              fontFamily: 'Cairo, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#d85a2a';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#E96A3A';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 0V4L12 0L8 4V0Z" fill="currentColor" opacity="0.5"/>
              <path d="M8 12V16L4 12L8 16V12Z" fill="currentColor" opacity="0.5"/>
              <path d="M16 8H12L16 4V8Z" fill="currentColor" opacity="0.5"/>
              <path d="M0 8H4L0 12V8Z" fill="currentColor" opacity="0.5"/>
              <path d="M13.65 2.35C12.2 0.9 10.2 0 8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C11.73 16 14.84 13.45 15.73 10H13.65C12.83 12.33 10.61 14 8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C9.66 2 11.14 2.69 12.22 3.78L9 7H16V0L13.65 2.35Z" fill="currentColor"/>
            </svg>
            تحديث البيانات
          </button>
        </div>

        {/* Stats Cards Section */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
          width: '100%'
        }}>
          <StatsCards key={refreshKey} />
        </div>

        {/* Charts Section */}
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) 420px',
          gap: '32px', 
          width: '100%',
          minHeight: '600px'
        }}>
          {/* Account Growth Chart - Right Side */}
          <div style={{ 
            minWidth: '0',
            width: '100%',
            height: '100%'
          }}>
            <AccountGrowthChart />
          </div>

          {/* Top Rated List - Left Side */}
          <div style={{ 
            width: '100%',
            height: '100%'
          }}>
            <TopRatedList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default الرئيسية;
